import { Component, OnInit,  Input, Output, EventEmitter } from '@angular/core';
import { GrupoFamiliar } from './grupo-familiar';
import { Estudo } from '../estudo/estudo';
import { GrupoFamiliarService } from './grupo-familiar.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { Questionario } from 'unb-questionario-componente';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { EstudoQuestionario } from '../estudo/estudo-questionario';
import { EstudoQuestionarioEnum} from  '../util/estudo-questionario.enum';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  templateUrl: './grupo-familiar-visualizar.component.html',
	selector: 'grupo-familiar-visualizar',
})

export class GrupoFamiliarVisualizarComponent implements OnInit {
    @Input() estudo : Estudo;

    public lista : GrupoFamiliar[];
    public isLoading: boolean;
    public questionarioCompleto:Questionario;
    public resposta: Resposta;
    public mostrarQuestionario: boolean = false;


    constructor(
      private mensagem: MatSnackBar,
      private estudoService: EstudoService,
      public dialog: MatDialog,
      private grupoFamiliarService: GrupoFamiliarService, 
      private respostaService: RespostaListaDinamicaService)  {
    }

    ngOnInit() {
      if(this.estudo.respostaQuestionarioDadosPessoais){
        this.carregaQuestionario();
      }
    }
   
  private carregaQuestionario(): void{
    this.estudoService.getQuestionario(null, this.estudo.id, EstudoQuestionarioEnum.grupoFamiliar)
    .subscribe((result: EstudoQuestionario) =>{
       this.questionarioCompleto = result.questionario;
       this.carregaLista();
      },
    error =>  this.erro(error));
    
  }

  private carregaLista(): void{
    this.isLoading= true;
    let filtro: GrupoFamiliar = new GrupoFamiliar;
    filtro.codigoEstudoSocioEconomico = this.estudo.id;
     this.grupoFamiliarService.filtrar(filtro).subscribe(
      (result:GrupoFamiliar[]) => {
          this.lista = result;
          this.isLoading= false;
      },
      error => this.erro(error));
    }

    public editarRecebido(grupoFamiliar: GrupoFamiliar): void {
      // carrego a respostaEmitida
      this.isLoading= true;
      this.mostrarQuestionario = false;
       this.respostaService.getRespostaCompletaPorPergunta(grupoFamiliar.respostaQuestionarioGrupoFamiliar).subscribe(
          (result:Resposta) =>{
            this.resposta = result;
            this.mostrarQuestionario = true;
            this.isLoading= false;
  
          },
          error =>  this.erro(error)
        );
    }
  
  // mostra erros na tela
   private erro(erro: string): void{
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading= false;
   }

   // finaliza o subscribe
   finaliza(): void{
     this.isLoading=false;
   }
}
